import { useImmerAtom } from 'jotai-immer';
import { pageStateAtom } from '../mfr_restrictions_list_atoms';
import { PageStoreHook } from '../mfr_restrictions_list_types';
import { useEffect } from 'react';
import utilSvc from '../../../../core/utilSvc';
import useNgContext from '../../../../core/services/useNgContext';

export const useMFRRestrictionsListStore = (): PageStoreHook => {
    const [state, setState] = useImmerAtom(pageStateAtom);
    const ctx = useNgContext();

    useEffect(() => {
        setState(draft => {
            draft.canEdit = utilSvc.user.hasFeature(ctx.User, 'admin.mfrestrict.edit');
        });
    }, [ctx.User, setState]);

    return {
        canEdit: state.canEdit,
    };
};
